/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pre-op-review-pac.reducer';

export const PreOpReviewPACDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const preOpReviewPACEntity = useAppSelector(state => state.preOpReviewPAC.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="preOpReviewPACDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.detail.title">PreOpReviewPAC</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.id">Id</Translate>
            </span>
          </dt>
          <dd>{preOpReviewPACEntity.id}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{preOpReviewPACEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.active">Active</Translate>
            </span>
          </dt>
          <dd>{preOpReviewPACEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{preOpReviewPACEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{preOpReviewPACEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{preOpReviewPACEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{preOpReviewPACEntity.timestampentry}</dd>
          <dt>
            <span id="fitForProcedure">
              <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.fitForProcedure">Fit For Procedure</Translate>
            </span>
          </dt>
          <dd>{preOpReviewPACEntity.fitForProcedure ? 'true' : 'false'}</dd>
          <dt>
            <span id="recomendedTypeOfAnaesthesia">
              <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.recomendedTypeOfAnaesthesia">Recomended Type Of Anaesthesia</Translate>
            </span>
          </dt>
          <dd>{preOpReviewPACEntity.recomendedTypeOfAnaesthesia}</dd>
          <dt>
            <span id="asaCategory">
              <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.asaCategory">Asa Category</Translate>
            </span>
          </dt>
          <dd>{preOpReviewPACEntity.asaCategory}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.surgery">Surgery</Translate>
          </dt>
          <dd>{preOpReviewPACEntity.surgery ? preOpReviewPACEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.preOpReviewPAC.reviewedBy">Reviewed By</Translate>
          </dt>
          <dd>{preOpReviewPACEntity.reviewedBy ? preOpReviewPACEntity.reviewedBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pre-op-review-pac" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pre-op-review-pac/${preOpReviewPACEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PreOpReviewPACDetail;
